import React, { useState } from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import { Query, withApollo } from 'react-apollo'
import { Avatar } from 'antd'
// import { Query } from 'react-apollo'
import gql from 'graphql-tag'

const USER_AVATAR = gql`
    query userAvatar(
		$user_uid: String
	) {
		userAvatar(
			user_uid: $user_uid
		)
    }
`

const UserAvatar = (props) => {
	const { 
		client, user_uid, ...rest 
	} = props

	return (
		
		<Query 
			query={USER_AVATAR}
			variables={{ user_uid }}
			fetchPolicy='network-only'
		>
			{({ loading, error, data }) => {
				const userAvatar = _.has(data, 'userAvatar') ? data.userAvatar : null
				//console.log('userAvatar', userAvatar)
				const avatarUrl = _.has(userAvatar, 'url') ? 
					`${process.env.REACT_APP_BACKEND_API}${userAvatar.url}` 
					: 'https://i.ya-webdesign.com/images/avatar-png-3.png'
				return (
					<Avatar { ...rest } icon="user" src={avatarUrl} />
				)
			}}
		</Query>
	)
}

const composed = compose(
	withApollo
)

export default composed(UserAvatar)